import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

import {
  getMemberFullName,
  resolveMediaUrl,
} from "../utils/teamManagerUtils";

export default function TeamTable({
  members,
  loading,
  totalRows,
  visibleCount,
  demoMode,
  onLoadMore,
  onEdit,
  onDelete,
}) {
  return (
    <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-white/10 dark:bg-slate-900">
      <div className="border-b border-slate-200 p-4 dark:border-white/10 sm:p-5 lg:p-6">
        <h2 className="text-xl font-bold text-slate-900 dark:text-white">
          Tableau des responsables
        </h2>

        <p className="mt-1 text-sm leading-6 text-slate-600 dark:text-slate-300">
          {totalRows.toLocaleString("fr-FR")} responsable
          {totalRows > 1 ? "s" : ""} trouvé{totalRows > 1 ? "s" : ""}.
        </p>
      </div>

      <div className="p-3 sm:p-5 lg:p-6">
        <div className="overflow-auto rounded-[24px] border border-slate-200 bg-white dark:border-white/10 dark:bg-slate-950/60">
          <table className="min-w-[980px] w-full text-sm">
            <thead className="sticky top-0 z-30 bg-slate-50 dark:bg-slate-900">
              <tr className="text-left">
                <th className="sticky left-0 z-40 bg-slate-50 px-4 py-3 font-bold text-slate-700 dark:bg-slate-900 dark:text-slate-200">
                  Photo
                </th>

                <th className="sticky left-[88px] z-40 bg-slate-50 px-4 py-3 font-bold text-slate-700 dark:bg-slate-900 dark:text-slate-200">
                  Responsable
                </th>

                <th className="px-4 py-3 font-bold text-slate-700 dark:text-slate-200">
                  Fonction
                </th>

                <th className="px-4 py-3 font-bold text-slate-700 dark:text-slate-200">
                  Position
                </th>

                <th className="px-4 py-3 text-right font-bold text-slate-700 dark:text-slate-200">
                  Actions
                </th>
              </tr>
            </thead>

            <tbody className="divide-y divide-slate-100 dark:divide-white/10">
              {loading ? (
                [...Array(8)].map((_, index) => (
                  <tr key={index}>
                    <td colSpan={5} className="px-4 py-3">
                      <div className="h-10 animate-pulse rounded-xl bg-slate-200 dark:bg-slate-800" />
                    </td>
                  </tr>
                ))
              ) : members.length === 0 ? (
                <tr>
                  <td
                    colSpan={5}
                    className="px-4 py-10 text-center text-slate-500 dark:text-slate-400"
                  >
                    Aucun responsable ne correspond aux filtres.
                  </td>
                </tr>
              ) : (
                members.map((member) => (
                  <tr
                    key={member.id}
                    className="transition hover:bg-slate-50 dark:hover:bg-slate-900"
                  >
                    <td className="sticky left-0 z-20 bg-white px-4 py-3 dark:bg-slate-950">
                      <img
                        src={resolveMediaUrl(member.photoURL)}
                        alt={getMemberFullName(member)}
                        className="h-12 w-12 rounded-2xl object-cover ring-1 ring-slate-200 dark:ring-slate-700"
                        onError={(event) => {
                          event.currentTarget.src = "/images/user_avatar.jpg";
                        }}
                      />
                    </td>

                    <td className="sticky left-[88px] z-20 bg-white px-4 py-3 dark:bg-slate-950">
                      <div className="font-bold text-slate-900 dark:text-white">
                        {getMemberFullName(member)}
                      </div>

                      <div className="mt-0.5 text-xs text-slate-500 dark:text-slate-400">
                        ID {member.id}
                      </div>
                    </td>

                    <td className="px-4 py-3 text-slate-700 dark:text-slate-300">
                      <span className="inline-flex rounded-full bg-primary/10 px-3 py-1 text-xs font-bold text-primary">
                        {member.fonction || "Non renseignée"}
                      </span>
                    </td>

                    <td className="px-4 py-3 font-bold text-slate-700 dark:text-slate-300">
                      {member.position ?? "—"}
                    </td>

                    <td className="px-4 py-3">
                      <div className="flex justify-end gap-2">
                        <button
                          type="button"
                          onClick={() => onEdit(member)}
                          disabled={demoMode}
                          className="flex h-9 w-9 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40 dark:border-white/10 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-white/10"
                          title="Modifier"
                        >
                          <FaEdit />
                        </button>

                        <button
                          type="button"
                          onClick={() => onDelete(member)}
                          disabled={demoMode}
                          className="flex h-9 w-9 items-center justify-center rounded-2xl bg-rose-600 text-white transition hover:bg-rose-700 disabled:cursor-not-allowed disabled:opacity-40"
                          title="Supprimer"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {!loading && visibleCount < totalRows && (
          <div className="mt-4 flex justify-center">
            <button
              type="button"
              onClick={onLoadMore}
              className="rounded-2xl border border-slate-200 bg-white px-5 py-2 text-sm font-bold text-slate-700 transition hover:bg-slate-50 dark:border-white/10 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-white/10"
            >
              Afficher plus ({visibleCount} / {totalRows})
            </button>
          </div>
        )}
      </div>
    </div>
  );
}